<div class="editor-container">
    <div
        [froalaEditor]="froalaOptions()"
        [froalaModel]="editorContent()"
        (froalaModelChange)="contentChanged($event)"></div>
</div>
